import { render } from "./RequestSampleFormModal.vue?vue&type=template&id=496852f0"
import script from "./RequestSampleFormModal.vue?vue&type=script&lang=js"
export * from "./RequestSampleFormModal.vue?vue&type=script&lang=js"

import "./RequestSampleFormModal.vue?vue&type=style&index=0&id=496852f0&lang=less"

import exportComponent from "/builds/sun-chemical/color-materials/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__